/// <reference path='../../modules/app.module.ts'/>
/// <reference path="../../controllers/shell.controller.ts" />

module App {
    var getRoutes = (): App.Interfaces.ICustomState[] => {
        var route: App.Interfaces.ICustomState = {
            name: Constants.routeKeys.saved,
            url: '/' + 'saved',
            cache: false,
            title: 'Afspraak opgeslagen',
            headerTitle: 'Afspraak opgeslagen',
            configuratorStepName: ['SaveAppointmentStep', 'SaveAppointmentToDatabaseStep', 'TyreChangeMailStep'],
            order: 7,
            operations: ['SetTankYou'],
            views: {
                [Constants.viewRegions.appContent]: {
                    templateUrl: '/templates/appointmentsaved.html',
                    controller: Controllers.AppointmentSavedController.controllerId + ' as vm'
                }
            },
            showInMenu: false
        }

        return [route];
    }

    function appRun(routehelper: Blocks.Interfaces.IRouterFactory) {
        routehelper.configureRoutes(getRoutes());
    }

    App.Core.appCore.run(appRun);
}